<script>
  let { ...rest } = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="250"
  height="181"
  viewBox="0 0 250 181"
  fill="currentColor"
  {...rest}
>
  <rect
    y="34.5001"
    width="250"
    height="146"
    rx="4"
    stroke="currentColor"
    stroke-width="10"
    fill="none"
  />
  <line x1="27" y1="62" x2="77" y2="62" stroke="currentColor" stroke-width="5" />
  <line x1="27" y1="77.8887" x2="77" y2="77.8887" stroke="currentColor" stroke-width="5" />
  <line x1="27" y1="97.4453" x2="221" y2="97.4453" stroke="currentColor" stroke-width="5" />
  <line x1="27" y1="114.555" x2="221" y2="114.555" stroke="currentColor" stroke-width="5" />
  <line x1="27" y1="132.889" x2="221" y2="132.889" stroke="currentColor" stroke-width="5" />
  <line x1="27" y1="150" x2="221" y2="150" stroke="currentColor" stroke-width="5" />
</svg>
